export default {
    root: ({props}) => ({
        class: [
            // Flexbox
            "flex flex-col",

            // Position
            "relative",
            {
                "!transition-none !transform-none !w-screen !h-screen !max-h-full !top-0 !left-0":
                    props.position == "full",
            },

            // Size
            {
                "h-full w-80": props.position == "left" || props.position == "right",
                "h-auto w-full max-h-dvh": props.position == "top" || props.position == "bottom",
            },

            {
                "rounded-b-lg": props.position == "top",
                "rounded-t-lg": props.position == "bottom",
                "rounded--l-lg": props.position == "right",
                "rounded--r-lg": props.position == "left",
            },

            // Shape
            "border-0",
            "shadow-xl shadow-black",

            // Colors
            "bg-white dark:bg-stone-900",
            "text-stone-700 dark:text-white/80",
            "dark:border-stone-700",

            // Transitions
            "transition-transform",
            "duration-300",

            // Misc
            "pointer-events-auto",
        ],
    }),
    header: {
        class: [
            // Flexbox and Alignment
            "flex items-center justify-between",
            "shrink-0",

            // Spacing
            "px-4 lg:px-5 py-3 lg:py-4",

            // Colors
            "bg-white dark:bg-stone-900",
            "text-stone-700 dark:text-white/80",
        ],
    },
    title: {
        class: ["font-bold text-lg"],
    },
    icons: {
        class: ["flex items-center"],
    },
    pcclosebutton: {
        root: {
            class: [
                "relative",

                // Flexbox and Alignment
                "flex items-center justify-center",

                // Size and Spacing
                "mr-2 !gap-0",
                "last:mr-0",
                "w-8 h-8 !p-0",

                // Shape
                "border-0",
                "rounded-full",

                // Colors
                "text-stone-500",
                "bg-transparent",

                // Transitions
                "transition duration-200 ease-in-out",

                // States
                "hover:text-stone-700 dark:hover:text-white/80",
                "hover:bg-stone-100 dark:hover:bg-stone-800/80",
                "focus:!outline-none focus:outline-offset-0 focus:!ring-none focus:!ring-0",

                // Misc
                "overflow-hidden",
            ],
        },
        label: {class: ["hidden"]},
    },
    closeButtonIcon: {
        class: [
            // Display
            "inline-block",

            // Size
            "w-4",
            "h-4",
        ],
    },
    content: {
        class: [
            // Spacing and Size
            "px--2",
            // "pt-0",
            "h-full",
            "w-full",

            // Growth and Overflow
            "flex flex-col grow",
            "overflow-hidden",
            "overscroll-y-contain",
        ],
    },
    mask: ({props}) => ({
        class: [
            // Transitions
            "transition-all",
            "duration-200",
            {"p-5": !props.position == "full"},

            // Background and Effects
            {
                "has-[.mask-active]:bg-transparent bg-black/40": props.modal,
                "has-[.mask-active]:backdrop-blur-none backdrop-blur-sm": props.modal,
            },
        ],
    }),
    transition: ({props}) => {
        return props.position === "top"
            ? {
                  enterFromClass: "translate-x-0 -translate-y-full translate-z-0 mask-active",
                  leaveToClass: "translate-x-0 -translate-y-full translate-z-0 mask-active",
              }
            : props.position === "bottom"
              ? {
                    enterFromClass: "translate-x-0 translate-y-full translate-z-0 mask-active",
                    leaveToClass: "translate-x-0 translate-y-full translate-z-0 mask-active",
                }
              : props.position === "left"
                ? {
                      enterFromClass: "-translate-x-full translate-y-0 translate-z-0 mask-active",
                      leaveToClass: "-translate-x-full translate-y-0 translate-z-0 mask-active",
                  }
                : props.position === "right"
                  ? {
                        enterFromClass: "translate-x-full translate-y-0 translate-z-0 mask-active",
                        leaveToClass: "translate-x-full translate-y-0 translate-z-0 mask-active",
                    }
                  : {
                        enterFromClass: "opacity-0 mask-active",
                        enterActiveClass: "transition-opacity duration-200 ease-in",
                        leaveActiveClass: "transition-opacity duration-200 ease-in",
                        leaveToClass: "opacity-0 mask-active",
                    };
    },
};
